/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import InstagramApi from 'scripts/social/instagram';
import template from './instagram-embed.stache';

const POST_URL_REG_EXP = /https?:\/\/(www.)?instagram\.com\/p\/([^\/\?#]+)/ig;

Component.extend({
    tag: 'instagram-embed',
    template: template,
    events: {
        inserted: function () {
            InstagramApi.create(this.element.find('.c-instagram-embed'), {embed: this.viewModel.attr('embed')})
        },

        parsePostUrl: function () {
            if (this.viewModel.attr('postUrl')) {
                let regexp = new RegExp(POST_URL_REG_EXP);
                let hrefArr = regexp.exec(this.viewModel.attr('postUrl'));
                return hrefArr && hrefArr[2] ? hrefArr[2] : null;
            } else{
                return null;
            }
        }
    }
});
